import { Route } from "components/Route";
import { Switch } from "react-router-dom";
import { routes } from "routes";
import { ChangePasswordPage } from "./ChangePasswordPage";
import { ChangeEmailPage } from "./ChangeEmailPage/ChangeEmailPage";
import { CreateAccountsPage } from "./CreateAccountsPage";
import { PeoplePage } from "./PeoplePage";
import { ProfilePage } from "./ProfilePage";
import { UpdateChildPage } from "./UpdateChildPage";
import { ChangeNamePage } from "./ChangeNamePage/ChangeNamePage";

export const PeopleSwitch = (): JSX.Element => (
	<Switch>
		<Route exact path={routes._.people._.createAccounts.path}>
			<CreateAccountsPage />
		</Route>

		<Route
			exact
			path={[routes._.people._.userProfile.path, routes._.people._.me.path]}
		>
			<ProfilePage />
		</Route>

		<Route
			path={[
				routes._.people._.userProfile._.resetPassword.path,
				routes._.people._.me._.changePassword.path,
			]}
		>
			<ChangePasswordPage />
		</Route>

		<Route path={[routes._.people._.me._.changeEmail.path]}>
			<ChangeEmailPage />
		</Route>

		<Route path={[routes._.people._.me._.changeName.path]}>
			<ChangeNamePage />
		</Route>

		<Route
			path={[
				routes._.people._.userProfile._.updateChild.path,
				routes._.people._.me._.updateChild.path,
			]}
		>
			<UpdateChildPage />
		</Route>

		<Route path={routes._.people.path}>
			<PeoplePage />
		</Route>
	</Switch>
);
